import EmblaCarousel from 'embla-carousel';
import { useRef, useCallback, useEffect } from 'react';
import { useShallow } from './hooks.mjs';

function useEmblaCarousel(options = {}, plugins = []) {
    const storedOptions = useRef(options);
    const storedPlugins = useRef(plugins);
    const emblaApi = useRef(undefined);
    const reInit = useCallback((options)=>{
        if (emblaApi) emblaApi.current?.reInit(options, storedPlugins.current);
    }, [
        emblaApi
    ]);
    const init = useCallback((ref)=>{
        if (!ref) return;
        const destroy = ()=>{
            if (emblaApi.current) {
                emblaApi.current.destroy();
                emblaApi.current = undefined;
            }
        };
        if (emblaApi.current) return destroy;
        const newEmblaApi = EmblaCarousel(ref, storedOptions.current, storedPlugins.current);
        emblaApi.current = newEmblaApi;
        return destroy;
    }, []);
    const stableOptions = useShallow(options);
    useEffect(()=>{
        reInit(options);
    }, [
        stableOptions
    ]);
    return [
        init,
        emblaApi
    ];
}

export { useEmblaCarousel };
